import { ServicesCategoryValues } from '@/components/forms/form-services-category/FormServicesCategory';
import useGetSportById from '@/hooks/queries/sports-api/useGetSportById';
import usePatchSports from '@/hooks/queries/sports-api/usePatchSports';
import { getChangedValues } from '@/utils/forms';
import { useParams } from 'react-router-dom';

const useEditServiceCaegory = () => {
  const { id } = useParams();
  const {
    data: sport,
    isPending: isPendingGet,
    isError,
    isLoading
  } = useGetSportById(id);
  const { mutate, isPending: isPendingPatch } = usePatchSports();
  const isPending = isPendingGet && isPendingPatch;

  const defaultValues = {
    name: sport?.name ?? '',
    description: sport?.description ?? ''
  };

  const onSubmit = (data: ServicesCategoryValues) => {
    const onlyChangedData = getChangedValues<Partial<ServicesCategoryValues>>(
      defaultValues,
      data
    );
    mutate({
      payload: onlyChangedData,
      sportId: sport?.id ?? ''
    });
  };

  return {
    sport,
    isError,
    isLoading,
    isPending,
    defaultValues,
    onSubmit
  };
};

export default useEditServiceCaegory;
